var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wt-selector',{attrs:{"options":_vm.options,"disabled":_vm.disabled,"clearable":true,"multiple":_vm.hasExamList,"filterable":_vm.filterable},model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}})}
var staticRenderFns = []

export { render, staticRenderFns }